// extracted by mini-css-extract-plugin
export default {"root":"TopicList_root__-IDFD"};